const normalizeImageOrder = (imageFiles) => {
    return imageFiles
        .filter(img => img)
        .map((img, index) => ({
            ...img,
            image_order: index + 1, // ← 1始まり
        }));
};
export const prepareProductPayload = ({ data, dataset, imageFiles = [], variants = [], specs = [] }) => {

    const orderedImages = normalizeImageOrder(imageFiles);
    // ファイルがあるかどうかで FormData にするか判断
    const hasFiles = imageFiles.some(img => img?.file instanceof File) ||
        variants.some(v => (v.imageFiles || []).some(img => img?.file instanceof File)) ||
        data.catalog_pdf instanceof File;

    if (!hasFiles) {
        // JSON 形式
        return {
            ...dataset,
            ...data,
            specs,
            images: orderedImages,
            variants,
            //deleted_variant_ids: variants.filter(v => v.willDelete && v.variant_id).map(v => v.variant_id),
        };
    }

    // --- FormData 形式 ---
    const formData = new FormData();
    formData.append("productData", JSON.stringify({
        ...dataset,
        ...data,
        specs,
        images: orderedImages,
        variants,
        //deleted_variant_ids: variants.filter(v => v.willDelete && v.variant_id).map(v => v.variant_id),
    }));

    // 商品画像
    orderedImages.forEach(img => {
        if (img?.file) formData.append('product_images', img.file);
    });

    variants.forEach((variant, variantIndex) => {
        (variant.imageFiles || []).forEach(img => {
            if (img?.file instanceof File) {
                formData.append('variant_images', img.file);

                // ★ 既存 / 新規で分岐
                formData.append(
                    'variant_image_meta[]',
                    JSON.stringify(
                        variant.variant_id
                            ? { variant_id: variant.variant_id }
                            : { variant_temp_id: variant.temp_id }
                    )
                );
            }
        });
    });
    // PDF
    if (data.catalog_pdf instanceof File) {
        formData.append('catalog_pdf', data.catalog_pdf);
    }
    return formData;
};
